export const mainMenuInitialState = {
  isMenuOpen: false,
  isDelMenuExpanded: false,
  isJsaMenuExpanded: false,
  isSamplingEventsMenuExpanded: false,
  isSafetyFormsMenuExpanded: false,
};
